import {Button} from 'bigdatr-style';
import {Ul} from 'bigdatr-style/layout';
import React from 'react';
import api from '~/api';
import {useRoutes} from '~/app/Router';

export default function CampaignGrouping() {
    const routes = useRoutes();
    const submitTrackingForm = api.useSubmitHubspotForm();

    return (
        <>
            <p>
                Advertising Creative now includes a Campaign toggle that automatically groups
                similar creatives. This means all variations of a campaign, across different
                channels and time periods, are now organised together in one view.
            </p>

            <p>
                No more scrolling through hundreds of individual creatives to find what belongs
                together! Get the full picture, faster:
            </p>

            <Ul>
                <li>See exactly when each creative variant went live</li>
                <li>Track which channels each version appeared on</li>
                <li>Identify patterns and themes across competitor’s creative strategy</li>
                <li>Compare activity of creative variants side-by-side using Creative Index</li>
            </Ul>

            <p>This feature is now available in your creative library.</p>

            <p>
                <Button
                    onClick={() => {
                        submitTrackingForm.mutate({formId: 'ec2f7072-3fc9-4860-98b2-c88c1776b2ef'});
                        routes.exploreCreative.push({
                            groupByCampaign: true,
                            filter: {
                                creativeDateRange: {relative: {months: 3}},
                                status: ['active', 'new']
                            },
                            creativeListOrderBy: {field: 'lastAppeared', order: 'DESC'}
                        });
                    }}
                >
                    Go to Campaign view
                </Button>
            </p>
        </>
    );
}
